import { Inject, Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { forkJoin, NEVER, Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { GlobalSettingsService } from '../services/ui/global-settings.service';
import { MyWorkService } from '../services/sections/job/my-work.service';
import { AccountRouteService } from '../services/interfaces/account-route-service.abstract';
import { AuthPage } from '../models/auth/auth-page.model';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../services/auth.service';
import { SiteNotesService } from '../services/sections/site-notes/site-notes.service';
import { DeficienciesService } from '../services/sections/deficiencies/deficiencies.service';

@Injectable({
	providedIn: 'root'
})
export class AccountRouteUrlResolver implements Resolve<Observable<Map<AuthPage, string>>> {

	constructor(
		private router: Router,
		private httpClient: HttpClient,
		private authService: AuthService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

		GlobalSettingsService.isSecondaryLoaderLoading = true;

		const authPages: AuthPage[] = activatedRouteSnapshot.data.authPages || [];

		if (!authPages?.length) {
			this.router.navigate(['/404']);
			GlobalSettingsService.isSecondaryLoaderLoading = false;
			return NEVER;
		}

		return forkJoin(
			authPages.map(page => {
				const service = this.getPageService(page);
				if (!service) {
					console.error(page + ' is not a valid page type!');
					return of('');
				}

				return service.getRedirectUri(activatedRouteSnapshot.paramMap.get('token'))
					.pipe(
						catchError((err) => {
							this.router.navigate(['/404']);
							GlobalSettingsService.isSecondaryLoaderLoading = false;
							return NEVER;
						}),
						map((uri) => uri.smartSyncUri)
					);
			})
		)
		.pipe(
			map(result => {
				const dictionary = new Map<AuthPage, string>();
				result.forEach((item, index) => dictionary.set(authPages[index], item));

				return dictionary;
			})
		);
	}

	private getPageService(pageType: AuthPage): AccountRouteService {
		switch (pageType) {
			case AuthPage.MyWork: return new MyWorkService(this.httpClient, this.authService);
			case AuthPage.SiteNotes: return new SiteNotesService(this.httpClient, this.authService);
			case AuthPage.Deficiencies: return new DeficienciesService(this.httpClient, this.authService);
			default: return null;
		}
	}
}
